import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import AccordionItem from "../components/accordion.jsx";
import PageHero from "../components/pageHero.jsx";
import SectionContent from "../components/sectionContent.jsx";
import { FaqContext } from "../context/FaqContext.jsx";
import { useLocalePath } from "../hooks/useLocalePath";
import { absoluteUrl } from "../seoUtils";

const Faq = () => {
  const { faqItems } = useContext(FaqContext);
  const { locale } = useLocalePath();
  const faqUrl = absoluteUrl(locale, "/faq");

  const schemaOrgFaq = faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer || "",
    },
  }));

  return (
    <>
      <Helmet>
        <title>AS Maskiner - Vanliga frågor | FAQ om nya och begagnade maskiner</title>
        <meta
          name="description"
          content="Få svar på dina vanligaste frågor om AS Maskiners produkter och tjänster. Vi säljer nya och begagnade CNC-maskiner, kantlistmaskiner, sprutautomater, fladderputs, bredbandputsar från fabrikat som KDT, SCM, Homag, Biesse, KA MA, AES, Viet, Felder, Masterwood, Holz-Her och Weinig."
        />
        <meta
          name="keywords"
          content="AS Maskiner, nya och begagnade maskiner FAQ, CNC fräs, KDT, Homag, Biesse, SCM, Morbidelli, KA MA, AES, Viet, Felder, Masterwood, Holz-Her, Weinig, kantlistmaskin, sprutautomat, fladderputs, bredbandputs, plattuppdelningssåg, listhyvel, köpa maskin snickeri"
        />
        <meta property="og:url" content={faqUrl} />
        <meta property="og:title" content="Vanliga frågor - AS Maskiner" />
        <meta
          property="og:description"
          content="Svar på vanliga frågor om köp av nya och begagnade maskiner från KDT, SCM, Homag, Biesse m.fl."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            url: faqUrl,
            name: "Vanliga frågor",
            description:
              "Få svar på dina vanligaste frågor om AS Maskiners produkter och tjänster på vår FAQ-sida.",
            mainEntity: schemaOrgFaq,
          })}
        </script>
      </Helmet>

      <PageHero
        titleKey="faq.hero_title"
        titleFallback="Vanliga frågor"
        subtitleKey="faq.hero_subtitle"
        backgroundKey="faq.hero_background"
        alignment="bottom"
      />

      <section className="py-16 bg-white">
        <SectionContent>
          <dl>
            {faqItems.map((item) => (
              <AccordionItem key={item.id} question={item.question} answer={item.answer} />
            ))}
          </dl>
        </SectionContent>
      </section>
    </>
  );
};

export default Faq;
